import { create, StateCreator } from "zustand";
import { devtools } from "zustand/middleware";

/**
 * Creates a Zustand store with devtools middleware.
 * Use this as the base factory for all OEM stores.
 *
 * Usage:
 *   export const useMyStore = createStore<MyState>((set, get) => ({
 *     value: initialValue,
 *     setValue: (v) => set({ value: v }),
 *   }));
 */
export function createStore<T>(
  init: StateCreator<T, [["zustand/devtools", never]], []>,
  name?: string,
) {
  return create<T>()(devtools(init, { name }));
}
